import { render, staticRenderFns } from "./ComponentSettingsDuplicateFormItem.vue?vue&type=template&id=7b6973ee&scoped=true"
import script from "./ComponentSettingsDuplicateFormItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentSettingsDuplicateFormItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentSettingsDuplicateFormItem.vue?vue&type=style&index=0&id=7b6973ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6973ee",
  null
  
)

export default component.exports